import React from 'react';
import logo from './nibbler-live.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo"/>
      </header>
    </div>
  );
}

export default App;
